<main>
	<div class="inner">
		<p class="main-text" translate>page-not-found</p>
		<p class="sub-text" translate>page-not-found-message</p>
		<div class="btn">
			<a [routerLink]="['/']" class="el-btn" translate>back-to-top</a>
		</div>
	</div>
</main>
